import { Lock } from "lucide-react";

/**
 * Shared no-access/loading UI for pages that self-enforce a `useRouteGate`
 * check (the same pattern LeadershipKPI.tsx originated: page-level guard +
 * locked card, not a route-level redirect). Extracted because the RLS
 * phase2-final directory/HR lockdown (Task A2) adds this exact pair to four
 * pages verbatim — Staff.tsx, StaffProfile.tsx, ComplianceDashboard.tsx,
 * Hub.tsx.
 */
export function RouteGateLoading(): JSX.Element {
  return (
    <div className="flex h-64 items-center justify-center" role="status" aria-label="Checking access">
      <div className="h-8 w-8 animate-spin rounded-full border-4 border-muted border-t-primary" />
    </div>
  );
}

export function RouteGateDenied({ title, description }: { title: string; description: string }): JSX.Element {
  return (
    <div className="mx-auto max-w-md py-16 text-center">
      <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-muted">
        <Lock className="h-6 w-6 text-muted-foreground" />
      </div>
      <h1 className="text-2xl font-bold tracking-tight">{title}</h1>
      <p className="mt-2 text-sm text-muted-foreground">{description}</p>
    </div>
  );
}
